import React, { useState, useEffect } from 'react';
import './Payement.css';
import DashboardHeader from '../components/DashboardHeader';
import ParentSidebar from '../components/ParentSidebar';
import { InfoIcon, HomeIcon, CameraIcon, CreditCardIcon } from '../components/Icons';

function Payement() {
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [studentInfo, setStudentInfo] = useState(null);
  const [formData, setFormData] = useState({
    montant: '',
    categorie: '',
    motif: '',
    numero: ''
  });

  useEffect(() => {
    fetchStudentInfo();
  }, []);

  const fetchStudentInfo = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('http://127.0.0.1:8000/api/v1/etudiant/me', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setStudentInfo(data.etudiant);
      }
    } catch (err) {
      console.error('Erreur lors du chargement des informations:', err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!paymentMethod) {
      setError('Veuillez sélectionner un mode de paiement');
      return;
    }

    if (!formData.montant || parseFloat(formData.montant) <= 0) {
      setError('Veuillez entrer un montant valide');
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch('http://127.0.0.1:8000/api/v1/paiements/creer', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          type: formData.motif,
          montant: parseFloat(formData.montant),
          mode_paiement: paymentMethod,
          trimestre: formData.categorie,
          numero_telephone: formData.numero
        })
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess('Paiement enregistré avec succès!');
        setTimeout(() => {
          setShowPaymentModal(false);
          setFormData({
            montant: '',
            categorie: '',
            motif: '',
            numero: ''
          });
          setPaymentMethod('');
          // Navigation vers l'historique
          if (window.navigateTo) {
            window.navigateTo('historique');
          }
        }, 1500);
      } else {
        setError(data.message || 'Erreur lors de l\'enregistrement du paiement');
      }
    } catch (err) {
      setError('Erreur de connexion au serveur');
      console.error('Erreur:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <div className="admin-container">
        <ParentSidebar activePage="payement" />
        <main className="parent-main">
          <div className="parent-content">
            <div className="main-content">
              {/* Student Info Card */}
              {studentInfo && (
                <div className="student-info-card">
                  <div className="info-section">
                    <h3>Information Générale</h3>
                    <div className="info-grid">
                      <p><strong>Nom :</strong> {studentInfo.nom}</p>
                      <p><strong>Prénom :</strong> {studentInfo.prenom}</p>
                      <p><strong>Né (e) le :</strong> {studentInfo.date_naissance}</p>
                      <p><strong>Matricule :</strong> {studentInfo.matricule}</p>
                      <p><strong>Classe :</strong> {studentInfo.classe?.nom || 'Non assigné'}</p>
                    </div>
                  </div>

                  <div className="info-media">
                    {studentInfo.photo ? (
                      <img src={`http://127.0.0.1:8000/storage/${studentInfo.photo}`} alt="Photo" className="student-photo" />
                    ) : (
                      <div className="student-photo"><CameraIcon size={24} /></div>
                    )}
                  </div>
                </div>
              )}

              {/* Payment Section */}
              <div className="payment-section">
                <h2>Effectuer un paiement</h2>
                <p className="payment-description">Cliquez sur le bouton ci-dessous pour procéder au paiement de la scolarité</p>
                
                <button className="open-payment-btn" onClick={() => setShowPaymentModal(true)}>
                  <CreditCardIcon size={20} /> Payer la scolarité
                </button>
              </div>
            </div>

            {/* Right Sidebar */}
            <aside className="right-sidebar">
              <div className="breadcrumb">
                <span><HomeIcon size={16} /> Accueil › Paiements</span>
              </div>

              {studentInfo?.classe?.enseignant && (
                <div className="teacher-card">
                  <h4>L'enseignant</h4>
                  <div className="teacher-info">
                    <div className="teacher-avatar">
                      {studentInfo.classe.enseignant.nom?.charAt(0)}{studentInfo.classe.enseignant.prenom?.charAt(0)}
                    </div>
                    <div className="teacher-details">
                      <p className="teacher-name">
                        {studentInfo.classe.enseignant.nom} {studentInfo.classe.enseignant.prenom}
                      </p>
                      <p className="teacher-contact">{studentInfo.classe.enseignant.telephone}</p>
                    </div>
                  </div>
                </div>
              )}

              <button className="pay-btn" onClick={() => setShowPaymentModal(true)}>Payer la scolarité</button>
            </aside>
          </div>
        </main>
      </div>

      {/* Payment Modal */}
      {showPaymentModal && (
        <div className="payment-modal-overlay" onClick={() => setShowPaymentModal(false)}>
          <div className="payment-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowPaymentModal(false)}>✕</button>
            
            <h2 className="modal-title">Effectuer un paiement</h2>

            {error && <div className="alert alert-error">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}

            <form onSubmit={handlePaymentSubmit}>
              {studentInfo && (
                <div className="form-group">
                  <label>Élève</label>
                  <input
                    type="text"
                    value={`${studentInfo.nom} ${studentInfo.prenom} - ${studentInfo.matricule}`}
                    disabled
                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                  />
                </div>
              )}

              <div className="form-group">
                <label>Montant (FCFA) <span className="required">*</span></label>
                <input
                  type="number"
                  name="montant"
                  placeholder="Ex: 50000"
                  value={formData.montant}
                  onChange={handleInputChange}
                  required
                  min="1"
                />
              </div>

              <div className="form-group">
                <label>Motif de paiement <span className="required">*</span></label>
                <select
                  name="motif"
                  value={formData.motif}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Sélectionnez le motif</option>
                  <option value="scolarite">Frais de scolarité</option>
                  <option value="inscription">Frais d'inscription</option>
                  <option value="examen">Frais d'examen</option>
                  <option value="cantine">Frais de cantine</option>
                  <option value="transport">Frais de transport</option>
                  <option value="autre">Autre</option>
                </select>
              </div>

              <div className="form-group">
                <label>Trimestre/Période</label>
                <select
                  name="categorie"
                  value={formData.categorie}
                  onChange={handleInputChange}
                >
                  <option value="">Sélectionnez (optionnel)</option>
                  <option value="trimestre1">Trimestre 1</option>
                  <option value="trimestre2">Trimestre 2</option>
                  <option value="trimestre3">Trimestre 3</option>
                  <option value="annuel">Annuel</option>
                </select>
              </div>

              <div className="form-group">
                <label>Mode de payement <span className="required">*</span></label>
                <div className="payment-methods">
                  <div 
                    className={`payment-method-card ${paymentMethod === 'mobile' ? 'selected' : ''}`}
                    onClick={() => setPaymentMethod('mobile')}
                  >
                    <div className="payment-logos">
                      <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 40'%3E%3Crect fill='%23FFCC00' width='100' height='40' rx='5'/%3E%3Ctext x='50' y='25' font-family='Arial' font-size='16' font-weight='bold' fill='%23000' text-anchor='middle'%3EMTN%3C/text%3E%3C/svg%3E" alt="MTN" />
                      <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 40'%3E%3Crect fill='%23FF6B00' width='100' height='40' rx='5'/%3E%3Ctext x='50' y='25' font-family='Arial' font-size='14' font-weight='bold' fill='%23FFF' text-anchor='middle'%3EMOOV%3C/text%3E%3C/svg%3E" alt="Moov" />
                    </div>
                    <p className="payment-method-label">Mobile Money</p>
                  </div>

                  <div 
                    className={`payment-method-card ${paymentMethod === 'moneygram' ? 'selected' : ''}`}
                    onClick={() => setPaymentMethod('moneygram')}
                  >
                    <div className="payment-logo-single">
                      <svg viewBox="0 0 120 60" xmlns="http://www.w3.org/2000/svg">
                        <rect fill="#FF6B35" width="120" height="60" rx="8"/>
                        <text x="60" y="38" font-family="Arial, sans-serif" font-size="20" font-weight="bold" fill="white" text-anchor="middle">MoneyGram</text>
                      </svg>
                    </div>
                  </div>

                  <div 
                    className={`payment-method-card ${paymentMethod === 'visa' ? 'selected' : ''}`}
                    onClick={() => setPaymentMethod('visa')}
                  >
                    <div className="payment-logo-single">
                      <svg viewBox="0 0 120 60" xmlns="http://www.w3.org/2000/svg">
                        <rect fill="#1A1F71" width="120" height="60" rx="8"/>
                        <text x="60" y="38" font-family="Arial, sans-serif" font-size="24" font-weight="bold" fill="#F7B600" text-anchor="middle">VISA</text>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>Numéro <span className="required">*</span></label>
                <div className="phone-input">
                  <div className="country-code">
                    <span className="flag">🇧🇯</span>
                    <span>+229</span>
                  </div>
                  <input
                    type="tel"
                    name="numero"
                    placeholder="53917129"
                    value={formData.numero}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <button type="submit" className="submit-payment-btn" disabled={loading}>
                {loading ? 'Traitement en cours...' : 'Enregistrer le paiement'}
              </button>
              
              <p className="payment-note">
                <InfoIcon size={16} color="#004085" /> Votre paiement sera enregistré dans l'historique immédiatement.
              </p>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Payement;
